export enum Role {
    ADMINISTRATOR = "Администратор",
    MANAGER = "Менеджер",
    SUPPORT = "Поддержка",
    AGENT = "Агент",
    SECRETARY = "Секретарь",
    USER = "Пользователь",
    CLIENT = "Абонент-руководитель"
}
